export type ReleaseNoteCategory = 'Ny funksjon' | 'Forbedring' | 'Feilretting';

export interface ReleaseNote {
  id: number;
  version: string;
  releaseDate: string;
  category: string;
  title: string;
  description?: string;
  impact?: string;
  modules?: string; // Kommaseparerte modul-koder, f.eks. "pick,pack"
  sortOrder: number;
  createdBy?: string;
  created: string;
}

export interface ReleaseNoteVersion {
  version: string;
  releaseDate: string;
  notes: ReleaseNote[];
}

export interface DeployedVersion {
  id: number;
  environment: string;
  version: string;
  gitSha?: string;
  deployedAt: string;
  appStartedAt: string;
  lastSeenAt: string;
  machineName?: string;
}

export const RELEASE_NOTE_CATEGORIES: ReleaseNoteCategory[] = [
  'Ny funksjon',
  'Forbedring',
  'Feilretting'
];

/**
 * Tailwind classes for category badges.
 * Ny funksjon = grønn, Forbedring = blå, Feilretting = oransje.
 */
export const CATEGORY_BADGE_CLASSES: Record<string, string> = {
  'Ny funksjon': 'bg-green-100 text-green-800 border-green-200',
  'Forbedring': 'bg-blue-100 text-blue-800 border-blue-200',
  'Feilretting': 'bg-orange-100 text-orange-800 border-orange-200'
};

/**
 * Fast modul-vokabular (kode → visningsnavn). Må holdes i synk med
 * migrasjon 063 og release-notes-routinen (wms-release-notes-auto-sync).
 */
export const MODULE_LABELS: Record<string, string> = {
  pick: 'Plukk',
  receipt: 'Mottak',
  putaway: 'Plassering',
  count: 'Telling',
  pack: 'Pakking',
  correction: 'Korreksjon',
  relocation: 'Intern flytting',
  shipping: 'Forsendelse',
  ruleengine: 'Ruleengine',
  integration: 'Integrasjon',
  printing: 'Utskrift & etiketter',
  import: 'Import',
  masterdata: 'Masterdata',
  warehouse: 'Lageroppsett',
  reporting: 'Rapporter & dashboard',
  access: 'Brukere & tilgang',
  settings: 'Innstillinger/Profil',
  platform: 'Plattform'
};

// Rekkefølge for filter-nedtrekk (operatørfunksjoner først, så tverrgående/teknisk)
export const MODULE_ORDER: string[] = [
  'pick', 'receipt', 'putaway', 'count', 'pack', 'correction', 'relocation', 'shipping',
  'ruleengine', 'integration', 'printing', 'import', 'masterdata', 'warehouse',
  'reporting', 'access', 'settings', 'platform'
];

/** Splitter den kommaseparerte Modules-strengen til koder. */
export const parseModules = (modules?: string): string[] =>
  modules ? modules.split(',').map(m => m.trim()).filter(Boolean) : [];
